export default __webpack_public_path__ + "static/media/pinterest-logo.c903023b.svg";